import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { PviInsurancePlanDTO } from '@gtd/api-services/service-inventory';
import { InsuranceService } from '../../../services/insurance.service';

@Component({
  selector: 'gtd-pvi-insurance',
  templateUrl: './pvi-insurance.component.html',
  styleUrls: ['./pvi-insurance.component.scss']
})
export class PviInsuranceComponent implements OnInit, OnChanges {
  @Input() bookingNumber: string;
  @Input() type: 'DOME' | 'INTE';
  @Input() ageCalculateDate: string | Date;
  availablePlans: { label: string; value: string }[];
  insurers$ = this.insuranceService.insurers$;
  checked = this.insuranceService.checked;
  detailLink: string;
  constructor(private insuranceService: InsuranceService) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    const { type } = changes;
    if (!type) {
      return;
    }
    this.availablePlans =
      type.currentValue === 'DOME'
        ? this.insuranceService.domesticPlans
        : this.insuranceService.internationalPlans;
    this.detailLink =
      type.currentValue === 'DOME'
        ? '/assets/files/pvi-domestic.pdf'
        : '/assets/files/pvi-international.pdf';
  }
}
